import type { MessageKey } from '../../i18n';
import { createColumnsHook, type ColumnsState } from '../../lib/table-columns';

/**
 * Optional columns of the test case list. Key and title are not here: they
 * identify the row and are always shown.
 */
export const CASE_COLUMNS = [
  'folder',
  'status',
  'labels',
  'environment',
  'layer',
  'module',
  'priority',
  'severity',
  'automated',
  'author',
  'updated',
] as const;

export type CaseColumn = (typeof CASE_COLUMNS)[number];

export const CASE_COLUMN_LABELS: Record<CaseColumn, MessageKey> = {
  folder: 'common.folder',
  status: 'common.status',
  labels: 'labels.title',
  environment: 'common.environment',
  layer: 'common.layer',
  module: 'common.module',
  priority: 'enum.priorityLabel',
  severity: 'enum.severityLabel',
  automated: 'cases.automated',
  author: 'common.author',
  updated: 'common.updated',
};

/** What a QA engineer sees before touching anything. */
const DEFAULT_COLUMNS: CaseColumn[] = ['folder', 'priority', 'status', 'updated'];

export const CASE_COLUMNS_STORAGE_KEY = 'tms.caseColumns';

export type CaseColumnsState = ColumnsState<CaseColumn>;

export const useCaseColumns = createColumnsHook({
  columns: CASE_COLUMNS,
  defaults: DEFAULT_COLUMNS,
  storageKey: CASE_COLUMNS_STORAGE_KEY,
});
